import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, FileUploadOutlined } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate, baseURL } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { isSystemAccess } from "../../../ConfigInfo/Info";

const fileBaseURL = baseURL ? baseURL.replace("/api", "") : "";

const resolveDocUrl = (path) => {
  if (!path) return "";
  return /^https?:\/\//i.test(path) ? path : `${fileBaseURL}/${path}`;
};

const SiteModal = ({ mode, handleCloseClick, editData }) => {
  const [orgId, setOrgId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expiry, setExpiry] = useState("");
  const [expiryRef, setExpiryRef] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [logoPreview, setLogoPreview] = useState(
    mode === "Edit" ? resolveDocUrl(editData?.siteURL) : "",
  );
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);

  useEffect(() => {
    if (siteInfoDetail?.roleName === "Ora Admin") {
      // Set as an array for mapping
      setOrgId([
        {
          id: siteInfoDetail.organizationId,
          code: siteInfoDetail.organizationId, // Assuming code and organizationId are same
          organizationName: siteInfoDetail.organizationName,
        },
      ]);
    } else {
      getData(); // Fetch data only if not "Ora Admin"
    }
    getCountryList(); // Fetch country list on component mount
    if (mode === "Edit" && editData?.country) {
      getTimezone(editData.country);
    }
  }, []);

  const getData = async () => {
    const link = masterAPI["organization"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setOrgId(res.data.result);
      })
      .catch((e) => {
        setOrgId([]);
        console.log(e, "Site");
      });
    if (siteInfoDetail.roleName === "Ora Admin") {
      setOrgId(siteInfoDetail.organizationId);
    }
  };

  const getTimezone = async (countryCode) => {
    const link = masterAPI["selectList"].timeZones;
    await axiosPrivate
      .get(`${link}/${countryCode}`)
      .then((res) => {
        setTimeZoneList(res.data.result || res.data);
      })
      .catch((e) => {
        setTimeZoneList([]);
        console.log(e, "TimeZones");
      });
  };

  const getCountryList = async () => {
    const link = masterAPI["selectList"].getAllTimeZones;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setCountryList( res.data || []);
      })
      .catch((e) => {
        setCountryList([]);
        console.log(e, "Countries");
      });
  };

  const initialValue = {
    tokenExpiry: mode === "Edit" ? editData.tokenExpiry : 40,
    siteName: mode === "Edit" ? editData.siteName : "",
    code: mode === "Edit" ? editData.code : "",
    organizationId:
      siteInfoDetail?.roleName === "Ora Admin"
        ? siteInfoDetail.organizationId
        : mode === "Edit"
          ? editData.organizationId
          : "",
    runningNoforSR: mode === "Edit" ? editData.runningNoforSR : 1,
    runningNoforWO: mode === "Edit" ? editData.runningNoforWO : 1,
    runningNoforPM: mode === "Edit" ? editData.runningNoforPM : 1,
    runningNoforINSWO: mode === "Edit" ? editData.runningNoforINSWO : 1,
    runningNoforIssue: mode === "Edit" ? editData.runningNoforIssue : 1,
    runningNoforTransfer: mode === "Edit" ? editData.runningNoforTransfer : 1,
    runningNoforReturn: mode === "Edit" ? editData.runningNoforReturn : 1,
    runningNoPrefixLengthforPM:
      mode === "Edit" ? editData.runningNoPrefixLengthforPM : 5,
    runningNoPrefixLengthforSR:
      mode === "Edit" ? editData.runningNoPrefixLengthforSR : 5,
    runningNoPrefixLengthforWO:
      mode === "Edit" ? editData.runningNoPrefixLengthforWO : 5,
    runningNoPrefixLengthforINSWO:
      mode === "Edit" ? editData.runningNoPrefixLengthforINSWO : 5,
    runningNoPrefixLengthforIssue:
      mode === "Edit" ? editData.runningNoPrefixLengthforIssue : 5,
    runningNoPrefixLengthforTransfer:
      mode === "Edit" ? editData.runningNoPrefixLengthforTransfer : 5,
    runningNoPrefixLengthforReturn:
      mode === "Edit" ? editData.runningNoPrefixLengthforReturn : 5,
    refreshTokenExpiry: mode === "Edit" ? editData.refreshTokenExpiry : 60,
    offSetDaysforPMDueDate:
      mode === "Edit" ? editData.offSetDaysforPMDueDate : 0,
    useSysProInventory: mode === "Edit" ? editData.useSysProInventory : false,
    isSystem: mode === "Edit" ? editData.isSystem : false,
    country: mode === "Edit" ? editData.country : null,
    timeZone: mode === "Edit" ? editData.timeZone : null,
    siteURL: mode === "Edit" ? editData.siteURL : "",
    imageData: "",
    // fileUploadSize: mode === "Edit" ? editData.fileUploadSize : 5,
    maxFileSize: mode === "Edit" ? editData.maxFileSize : 100,
  };
  const onSubmit = async (value) => {
    if (value.tokenExpiry >= value.refreshTokenExpiry) {
      toast.error(
        "Access Token Expiry Time is lesser than or equal to Refresh Token Expiry",
      );
      return false;
    }
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["site"].create;
    const updateLink = masterAPI["site"].update;
    //  const roleCreateforSiteLink = masterAPI["import"].cloneapplicationroles;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, value)
        // .then((res) => {
        //   return axiosPrivate.post(`${roleCreateforSiteLink}/${res.data.id}`);
        // })
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "create Site");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "update Site");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };
  const formatTime = (minutes) => {
    if (!minutes || isNaN(minutes)) return "";
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hrs} Hour${hrs !== 1 ? "s" : ""} ${mins} Minute${
      mins !== 1 ? "s" : ""
    }`;
  };

  const handleLogoChange = (setFieldValue) => (e) => {
    if (e.target.files[0] !== undefined) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        const dataSplit = reader.result.split("base64,")[1];
        setFieldValue("siteURL", file.name);
        setFieldValue("imageData", dataSplit);
      };
      reader.onerror = function (error) {};
      setLogoPreview(URL.createObjectURL(file));
    } else {
      setFieldValue("siteURL", "");
      setFieldValue("imageData", "");
      setLogoPreview("");
    }
  };

  const handleClearLogo = (setFieldValue) => () => {
    setFieldValue("siteURL", "");
    setFieldValue("imageData", "");
    setLogoPreview("");
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? editData.code + "-" + editData.siteName
            : "New Site"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Site Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="siteName"
                  placeholder="Enter Site Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization
                </Typography>
                <Field
                  as={Select}
                  size="small"
                  type="text"
                  name="organizationId"
                  placeholder="Enter Organization"
                  fullWidth
                  displayEmpty
                  value={
                    siteInfoDetail?.roleName === "Ora Admin"
                      ? siteInfoDetail.organizationId
                      : initialValue.organizationId
                  }
                  disabled={
                    siteInfoDetail?.roleName === "Site Admin" ||
                    siteInfoDetail?.roleName === "Ora Admin"
                  }
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    initialValue.organizationId !== ""
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {orgId.map((id, i) => (
                    <MenuItem key={i} value={id.id}>
                      {id.organizationName}
                    </MenuItem>
                  ))}
                </Field>
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Country
                </Typography>
                <Autocomplete
                  size="small"
                  options={countryList}
                  getOptionLabel={(option) =>
                    `${option.text}`
                  }
                  value={
                    countryList.find((c) => c.value === values.country) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue !== null) {
                      setFieldValue("country", newValue ? newValue.value : null);
                      setFieldValue("timeZone", null);
                      if (newValue) {
                        getTimezone(newValue.value);
                      }
                    } else {
                      setFieldValue("country", null);
                      setFieldValue("timeZone", null);
                      setTimeZoneList([]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Country Code"
                      sx={{
                        ".MuiInputBase-input": {
                          "&::placeholder": {
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Time Zone
                </Typography>
                <Autocomplete
                  size="small"
                  disabled={!values.country}
                  options={timeZoneList}
                  getOptionLabel={(option) => option.text || option}
                  value={
                    timeZoneList.find((tz) => tz.text === values.timeZone) ||
                    null
                  }
                  onChange={(event, newValue) => {
                    if (newValue !== null) {
                      setFieldValue("timeZone", newValue.text);
                    } else {
                      setFieldValue("timeZone", null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Time Zone"
                      sx={{
                        ".MuiInputBase-input": {
                          "&::placeholder": {
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  File Upload Size (MB)
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="maxFileSize"
                  placeholder="Enter Max File Upload Size in MB"
                  fullWidth
                  inputProps={{ min: 0 }}
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site Logo
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <Button
                    component="label"
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      backgroundColor: color.TableButtonColor,
                      "&:hover": { backgroundColor: color.TableButtonColor },
                    }}
                  >
                    <FileUploadOutlined sx={{ fontSize: 18 }} />
                    <Typography sx={{ fontSize: "0.9rem", ml: 0.5 }}>
                      {logoPreview ? "Change Logo" : "Add File"}
                    </Typography>
                    <input
                      type="file"
                      accept={"image/*"}
                      hidden
                      onChange={handleLogoChange(setFieldValue)}
                    />
                  </Button>
                  {logoPreview && (
                    <IconButton
                      title="Clear Logo"
                      onClick={handleClearLogo(setFieldValue)}
                      sx={{ p: "4px" }}
                    >
                      <Clear sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                {logoPreview && (
                  <Typography
                    onClick={() => window.open(logoPreview, "_blank")}
                    sx={{
                      mt: "6px",
                      fontSize: color.labelFont,
                      color: color.TableButtonColor,
                      textDecoration: "underline",
                      cursor: "pointer",
                      width: "fit-content",
                      "&:hover": { color: color.masterDialogTitleColor },
                    }}
                  >
                    View Logo
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Work Order
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforWO"
                  placeholder="Enter No For WO"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Work Order
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforWO"
                  placeholder="Enter Prefix Length For WO"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Service Request
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforSR"
                  placeholder="Enter No For SR"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Service Request
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforSR"
                  placeholder="Enter Prefix Length For SR"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for PM
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforPM"
                  placeholder="Enter No For PM"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for PM
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforPM"
                  placeholder="Enter Prefix Length For PM"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Inspection Work Order
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforINSWO"
                  placeholder="Enter No For PM"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Inspection
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforINSWO"
                  placeholder="Enter Prefix Length For PM"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Issue
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforIssue"
                  placeholder="Enter No For Issue"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Issue
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforIssue"
                  placeholder="Enter Prefix Length For Issue"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Transfer
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforTransfer"
                  placeholder="Enter No For Transfer"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Transfer
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforTransfer"
                  placeholder="Enter Prefix Length For Transfer"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Running No for Return
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoforReturn"
                  placeholder="Enter No For Return"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Prefix Length for Return
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="runningNoPrefixLengthforReturn"
                  placeholder="Enter Prefix Length For Return"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>



              <Grid item xs={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Access Token Expiry
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="tokenExpiry"
                  placeholder="Enter Access Token Expiry"
                  fullWidth
                  inputProps={{ min: 0 }} // Prevents negative values
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Blocks negative input and scientific notation
                    }
                  }}
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <Typography
                  sx={{
                    mt: 1,
                    color: color.masterDialogTitleColor,
                    fontSize: "14px",
                    display: values.refreshTokenExpiry ? "default" : "none",
                  }}
                >
                  {formatTime(parseInt(values.tokenExpiry, 10))}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Refresh Token Expiry
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="refreshTokenExpiry"
                  placeholder="Enter Refresh Token Expiry"
                  fullWidth
                  inputProps={{ min: 0 }} // Prevents negative values
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Blocks negative input and scientific notation
                    }
                  }}
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />

                <Typography
                  sx={{
                    mt: 1,
                    color: color.masterDialogTitleColor,
                    fontSize: "14px",
                    display: values.refreshTokenExpiry ? "default" : "none",
                  }}
                >
                  {formatTime(parseInt(values.refreshTokenExpiry, 10))}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Syspro Inventory
                </Typography>
                <Switch
                  checked={values.useSysProInventory}
                  onChange={(e) => {
                    setFieldValue("useSysProInventory", e.target.checked);
                  }}
                />
              </Grid>

              {isSystemAccess(siteInfoDetail) && (
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    System
                  </Typography>
                  <Switch
                    checked={values.isSystem}
                    onChange={(e) => {
                      setFieldValue("isSystem", e.target.checked);
                    }}
                  />
                </Grid>
              )}

              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SiteModal;
